<template>
  <div class="main-content" :style="mainContentViewHeight"
       v-loading="dataListLoading">
    <el-form :inline="true"
             :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item label="关键字：">
        <el-input v-model="dataForm.searchKey" placeholder="关键字" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="searchByKeywords()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="showSearchDialogView()">高级查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      stripe
      v-if="hasLoadColumnInfo"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        fixed
        type="index"
        header-align="left"
        align="left"
        label="序号"
        width="60"
        :index="getRowsIndex"
      >
      </el-table-column>
      <el-table-column
        fixed
        v-if="false"
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        v-for="(item,index) in clomnLabelList"
        :fixed="getFixed(index)"
        :key="index"
        :prop="item.code"
        header-align="left"
        align="left"
        :title="item.name"
        :width="getColunnWidth(index)"
        :label="item.name">
      </el-table-column>
      <el-table-column
          v-if="formType == 0"
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showDetail(scope.row)">查看</el-button>
          <el-button v-if="false" type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalItemCount"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <show-detail-info v-if="showDetailInfoVisible" ref="showDetailInfo"/>
    <show-search-dialog v-if="showSearchVisible" ref="showSearch" @refreshDataList="searchByDialog"/>
  </div>
</template>

<script>
    import ShowDetailInfo from './detail'
    import ShowSearchDialog from './search'

    export default {
    props: ["mainContentViewHeight"],
    data() {
      return {
        dataForm: {
          userName: '',
          searchKey: '',
          type: '0'
        },
        formId: '',
        formType: '',
        dataList: [],
        searchColumnList: [],
        clomnLabelList: [],
        pageIndex: 1,
        pageSize: 10,
        totalItemCount: 0,
        dataListLoading: true,
        hasLoadColumnInfo: false,
        hasSearchColumns: false,
        dataListSelections: [],
        showSearchVisible: false,
        showDetailInfoVisible: false,
        searchArgs: {},
        searchType: 0,
      }
    },
    components: {
       ShowDetailInfo, ShowSearchDialog
    },
    activated() {
      this.formId = this.$route.params.formId
      this.formType = this.$route.params.formType
      if (this.$route.params.type) {
        this.dataForm.type = this.$route.params.type + ''
      } else {
        this.dataForm.type = '0'
      }
      this.initData()
    },
    methods: {
      getRowsIndex(index) {
        return (this.pageIndex - 1) * this.pageSize + index + 1
      },
      getFixed(index) {
        return index < 1
      },
      getColunnWidth(index) {
        return index < 1 ? "250" : "150"
      },
      getHttpReq(url, method = 'post', extOps) {
        let ops = {
          url: url,
          method: method
        }
        ops = Object.assign(ops, extOps)
        return this.$httpReq(ops)
      },
      showSearchDialogView() {
        this.showSearchVisible = true
        this.$nextTick(() => {
          this.$refs.showSearch.init(this.formId)
        })
      },
      searchByKeywords() {
        this.searchArgs = {}
        this.searchType = 0
        this.pageIndex = 1
        this.getDataList()
      },
      searchByDialog(args) {
        this.searchArgs = args
        this.searchType = 1
        this.pageIndex = 1
        this.getDataList()
      },
      // 获取数据列表
      getDataList() {
        let ops = {}
        let extArgs = {}
        if (this.searchType === 1) {
          if (this.searchArgs === undefined) {
            extArgs = this.searchArgs
          } else {
            extArgs = Object.assign(extArgs, this.searchArgs)
          }
          if (extArgs.searchKey === undefined) {
            extArgs.searchKey = ''
          }
          ops = {
            'page': this.pageIndex,
            'rows': this.pageSize,
            searchKey: extArgs.searchKey,
            filter: extArgs
          }
        } else {
          ops = {
            'page': this.pageIndex,
            'rows': this.pageSize,
            searchKey: this.dataForm.searchKey,
            filter: extArgs
          }
        }
        this.dataListLoading = true
        this.$httpReq({
          url: `/customform/query/list/${this.formId}`,
          method: 'post',
            baseURL: process.env.VUE_APP_proxybaseurl + '',
          data: ops
        }).then(({data}) => {
          if (data) {
            this.dataList = data.rows
            this.totalItemCount = data.total
          } else {
            this.dataList = []
            this.totalItemCount = 0
          }
          this.dataListLoading = false
          this.hasLoadColumnInfo = true
        })
      },
      initData() {
        if (this.formId === undefined) {
          this.$message.error('数据集无效')
          return
        }
        this.loadColumnInfo(this.formId)
      },
      loadColumnInfo(formId) {
        if (formId === undefined) {
          this.$message.error('数据集无效')
          return
        }
        this.$httpReq({
          url: "/customform/fromdatasetfield/listSingle",
          method: "post",
            baseURL: process.env.VUE_APP_proxybaseurl + '',
          data: {
            filter: {
              formId: this.formId,
              showInList:true
            },
            page: 1,
            rows: 100,
          },
        }).then(({data}) => {
          let result = []
          var columnList=[];
          if (data) {
            columnList = data.rows;
          }
          for (let index = 0; index < columnList.length; index++) {
            let columnItem=columnList[index];
            let item = {
              name: columnItem.displayName,
              code: columnItem.columnName
            }
            result.push(item)
          }
          this.clomnLabelList = result
          this.getDataList()
        })
      },
      // 每页数
      sizeChangeHandle(val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle(val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle(val) {
        this.dataListSelections = val
      },
      showDetail(row) {
        // debugger

        let paramMap = {
          tenderProjectCode:row.tender_project_code || '',
          bidSectionCode:row.bid_section_code || '',
          projectCode:row.project_code || ''
        }
        this.$router.push({
          name: "test_detail",
          params: { formId: this.formId,id:row.id, paramMap:paramMap, title: "自定义表单测试" },
        });
      },
      // 删除
      deleteHandle(id) {
        var userIds = id ? [id] : this.dataListSelections.map(item => {
          return item.userId
        })
        this.$confirm(`确定对[id=${userIds.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$httpReq({
            url: '/sys/user/delete',
            method: 'post',
            data: this.$httpReq.adornData(userIds, false)
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }).catch(() => {
        })
      }
    }
  }
</script>
<style scoped>
    .el-table .cell {
        word-break: normal;
    }

</style>
